import { TCCRelatedItems } from '../../../features/UserContractCategories/types'

export const initialCCRelatedItems: TCCRelatedItems = {
  rfp: [],
  contracts: []
}
